import { render, staticRenderFns } from "./submitDialog.vue?vue&type=template&id=b0dddedc&scoped=true&"
import script from "./submitDialog.vue?vue&type=script&lang=js&"
export * from "./submitDialog.vue?vue&type=script&lang=js&"
import style0 from "./submitDialog.vue?vue&type=style&index=0&id=b0dddedc&prod&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0dddedc",
  null
  
)

export default component.exports